import { ReactElement } from "react";
import { DateTime } from "luxon";

import { DataFile } from "@/redux/files/types";

export interface ContentItemProps {
  label?: string;
  content: ReactElement | undefined;
  showDivider?: boolean;
  layout?: "horizontal" | "vertical";
}

export interface FileElementProps {
  value: DataFile;
}

export interface FileGroupElementProps {
  value: DataFile[];
}

export enum TextType {
  REGULAR = "REGULAR",
  RICH_TEXT = "RICH_TEXT",
}

export enum FormatType {
  LINK = "LINK",
  IMAGE = "IMAGE",
}

export interface TextElementProps {
  value?: string | string[] | null;
  type: TextType;
  format?: FormatType;
  multiple: boolean;
}

export interface DateElementProps {
  value?: string | DateTime | null;
  format?: string;
}

export interface DateRangeElementProps {
  value?: string[] | null;
  format?: string;
}

export interface Tag {
  label: string;
  link?: string;
}

export interface TagsElementProps {
  value?: Tag[] | null;
}

export interface CheckboxElementProps {
  label: string;
  value: boolean;
}

export interface SliderDropdownValue {
  label: string;
  scaleLabel: string;
}

export interface SliderDropdownElementProps {
  value: SliderDropdownValue[];
}

export interface Option {
  label: string;
  value: number;
}

export interface SliderElementProps {
  value: number;
  options: Option[];
}
